/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * Run `yarn nx run order:generate-types` and edit the `.graphql` files
 *
 * See codegen config in .graphqlrc.yml for details
 */

/* eslint-disable unicorn/no-abusive-eslint-disable */ /* eslint-disable eslint-comments/no-unlimited-disable */ /* eslint-disable */ /* cspell:disable */

import * as Types from '../../../graphql/types';

import { ExecutionResult } from 'graphql';
import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ChallengeDataFragment = {
  readonly __typename?: 'Challenge';
  readonly achieved: number;
  readonly celebrationCopy: string;
  readonly descriptiveTitle: string;
  readonly expirationDate: any;
  readonly goal: number;
  readonly id: string;
  readonly legalTerms: string;
  readonly percentageCompleted: number;
  readonly permalink: string;
  readonly progress: number;
  readonly progressCopy: string;
  readonly status: Types.ChallengeStatus;
  readonly title: string;
};

export type ChallengesQueryVariables = Types.Exact<{ [key: string]: never }>;

export type ChallengesQuery = {
  readonly __typename?: 'Query';
  readonly challenges: ReadonlyArray<{
    readonly __typename?: 'Challenge';
    readonly achieved: number;
    readonly celebrationCopy: string;
    readonly descriptiveTitle: string;
    readonly expirationDate: any;
    readonly goal: number;
    readonly id: string;
    readonly legalTerms: string;
    readonly percentageCompleted: number;
    readonly permalink: string;
    readonly progress: number;
    readonly progressCopy: string;
    readonly status: Types.ChallengeStatus;
    readonly title: string;
  }>;
};

export type ChallengeOptInMutationVariables = Types.Exact<{
  challengeId: Types.Scalars['String'];
}>;

export type ChallengeOptInMutation = {
  readonly __typename?: 'Mutation';
  readonly challengeOptIn: {
    readonly __typename?: 'Challenge';
    readonly achieved: number;
    readonly celebrationCopy: string;
    readonly descriptiveTitle: string;
    readonly expirationDate: any;
    readonly goal: number;
    readonly id: string;
    readonly legalTerms: string;
    readonly percentageCompleted: number;
    readonly permalink: string;
    readonly progress: number;
    readonly progressCopy: string;
    readonly status: Types.ChallengeStatus;
    readonly title: string;
  };
};

export const challengesQueryMock: ExecutionResult<ChallengesQuery> = {
  data: {
    challenges: [
      {
        achieved: -27.84,
        celebrationCopy: 'Hello World',
        descriptiveTitle: 'Hello World',
        expirationDate: 'DateTime',
        goal: -95.27,
        id: '9e6ea9fe-e42a-4996-a587-ce71904308da',
        legalTerms: 'Hello World',
        percentageCompleted: -10.27,
        permalink: 'Hello World',
        progress: 27.95,
        progressCopy: 'Hello World',
        status: 'COMPLETED',
        title: 'Hello World',
      },
      {
        achieved: -11.63,
        celebrationCopy: 'Hello World',
        descriptiveTitle: 'Hello World',
        expirationDate: 'DateTime',
        goal: -85.61,
        id: '63ba7eda-96e8-4a18-9e3d-a00a9a475343',
        legalTerms: 'Hello World',
        percentageCompleted: -81.97,
        permalink: 'Hello World',
        progress: 14.41,
        progressCopy: 'Hello World',
        status: 'COMPLETED',
        title: 'Hello World',
      },
      {
        achieved: 70.04,
        celebrationCopy: 'Hello World',
        descriptiveTitle: 'Hello World',
        expirationDate: 'DateTime',
        goal: -89.93,
        id: '8060b59a-a250-4f9c-8016-b1bd634cb273',
        legalTerms: 'Hello World',
        percentageCompleted: 47.05,
        permalink: 'Hello World',
        progress: -10,
        progressCopy: 'Hello World',
        status: 'COMPLETED',
        title: 'Hello World',
      },
    ],
  },
};

export const challengeOptInMutationMock: ExecutionResult<ChallengeOptInMutation> =
  {
    data: {
      challengeOptIn: {
        achieved: 97.16,
        celebrationCopy: 'Hello World',
        descriptiveTitle: 'Hello World',
        expirationDate: 'DateTime',
        goal: 13.25,
        id: 'f18d030f-1b1f-42c4-9f5f-d7994ccdcab3',
        legalTerms: 'Hello World',
        percentageCompleted: 10.17,
        permalink: 'Hello World',
        progress: 46.49,
        progressCopy: 'Hello World',
        status: 'COMPLETED',
        title: 'Hello World',
      },
    },
  };
export const ChallengeDataFragmentDoc = gql`
  fragment ChallengeData on Challenge {
    achieved
    celebrationCopy
    descriptiveTitle
    expirationDate
    goal
    id
    legalTerms
    percentageCompleted
    permalink
    progress
    progressCopy
    status
    title
  }
`;
export const ChallengesDocument = gql`
  query Challenges {
    challenges {
      ...ChallengeData
    }
  }
  ${ChallengeDataFragmentDoc}
`;

export function useChallengesQuery(
  options?: Omit<Urql.UseQueryArgs<ChallengesQueryVariables>, 'query'>,
) {
  return Urql.useQuery<ChallengesQuery, ChallengesQueryVariables>({
    query: ChallengesDocument,
    ...options,
  });
}
export const ChallengeOptInDocument = gql`
  mutation challengeOptIn($challengeId: String!) {
    challengeOptIn(challengeId: $challengeId) {
      ...ChallengeData
    }
  }
  ${ChallengeDataFragmentDoc}
`;

export function useChallengeOptInMutation() {
  return Urql.useMutation<
    ChallengeOptInMutation,
    ChallengeOptInMutationVariables
  >(ChallengeOptInDocument);
}
